import { Link } from 'react-router-dom';
import LegalDocumentView from '../components/LegalDocumentView';
import { useLegalDocument } from '../hooks/useLegalDocument';

/**
 * The Terms and Conditions, as edited by a Super Admin. Public for the
 * same reason as the privacy notice — they are agreed to at
 * registration, so they have to be readable before it.
 */
const TermsPage = () => {
  const { content, loading } = useLegalDocument('terms');

  return (
    <div className="container" style={{ maxWidth: '48rem', padding: '2rem 1rem 4rem' }}>
      <Link to="/" style={{ fontSize: '0.9rem' }}>
        &larr; Back to the home page
      </Link>

      {loading ? <p style={{ marginTop: '2rem' }}>Loading...</p> : <LegalDocumentView content={content!} />}

      <p style={{ marginTop: '2.5rem', fontSize: '0.9rem' }}>
        See also the <Link to="/privacy">Data Privacy Policy</Link>.
      </p>
    </div>
  );
};

export default TermsPage;
